"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayStatusOwnerType = void 0;
var PayStatusOwnerType;
(function (PayStatusOwnerType) {
    PayStatusOwnerType["Availability"] = "availability";
    PayStatusOwnerType["UserEventRelation"] = "user_event_relation";
})(PayStatusOwnerType = exports.PayStatusOwnerType || (exports.PayStatusOwnerType = {}));
